const initialState = {
  currentLocationId: null,
  currentWeek: null,
  loading: {
    retrieveTimesheets: false,
  },
};

export default initialState;
